<template>
    <div :class="{
        'base-input': true,
        'base-input-is-error': isShowError
    }"  :style="{
        flex: flex
    }">
        <el-input v-bind="$attrs" v-on="$listeners" ref="elIpt">
            <slot name="prefix" slot="prefix" />
            <slot name="suffix" slot="suffix" />
            <slot name="prepend" slot="prepend" />
            <slot name="append" slot="append" />
        </el-input>
        <span v-if="isShowError" class="error-msg">{{ errorMsg }}</span>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'

export default createComponent({
    // 更多props扩展，欢迎自定义
    props: {
        flex: {             // flex布局的放大比例
            type: [Number, String],
            default: 1
        },
        isShowError: Boolean,
        errorMsg: String    // 错误展示信息
    },

    setup: (props, ctx) => {
        onMounted(() => {
            ctx.emit('recieve-ref', ctx.refs.elIpt)
        })
    }
})
</script>

<style lang="scss" scoped>
.base-input {
    position: relative;

    &.base-input-is-error {
        ::v-deep .el-input .el-input__inner {
            border-color: #e51c23;
        }
    }

    .error-msg {
        position: absolute;
        left: 0;
        bottom: -20px;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #e51c23;
    }
}
</style>
